import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { showError, showToast } from "../constants/toasts";
import { useAddInterestMutation } from "../service/cms";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  getInterestApi: () => void;
}

export default function AddInterest({
  open,
  onClose,
  setOpen,
  getInterestApi,
}: AddCategoryModalProps) {
  const [addInterest] = useAddInterestMutation();

  const [error, setError] = useState(false);
  const [interest, setInterest] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddFaq = async () => {
    setError(true);
    if (interest?.trim() === "") {
      showError("Interest is required");
      return;
    }

    setLoading(true);
    try {
      const body = {
        name: interest,
      };

      let response = await addInterest(body).unwrap();

      if (response?.status === 200) {
        setError(false);
        setOpen(false);
        showToast("Interest added successfully");
        getInterestApi();
        setInterest("");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add Interest</h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => {
                setInterest("");
                setOpen(false);
                setError(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleAddFaq();
            }}
          >
            <div className="control_group">
              <label htmlFor="interest">Interest Name</label>
              <TextField
                id="interest"
                placeholder="Enter Interest Name"
                fullWidth
                hiddenLabel
                value={interest}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setInterest(e.target.value);
                  }
                }}
              />
              {error && interest == "" ? (
                <h6 className="err_msg">Interest is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
